export enum enFrequencyType {
  DIARIO = 'D',
  MENSAL = 'M',
  ANUAL = 'Y'
}
